import type React from 'react';
import { CardHeader, Divider, CardContent, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';

import type { RequestProps } from '../../models';

const style = {
  divider: { borderBottomWidth: 1.5 },
};

interface EmploymentInfoProps {
  candidate: RequestProps['candidate'];
}

export const EmploymentInfo: React.FC<EmploymentInfoProps> = ({ candidate }) => (
  <>
    <CardHeader title="Employment" />
    <Divider sx={style.divider} />
    <CardContent>
      <Grid container spacing={2}>
        <Grid size={{ xs: 6 }}>
          <Typography variant="subtitle1" gutterBottom>
            Employer
          </Typography>
          <Typography variant="body1" gutterBottom>
            {candidate?.employer}
          </Typography>
        </Grid>
        <Grid size={{ xs: 6 }}>
          <Typography variant="subtitle1" gutterBottom>
            Job Role
          </Typography>
          <Typography variant="body1" gutterBottom>
            {candidate?.jobRole}
          </Typography>
        </Grid>
      </Grid>
    </CardContent>
  </>
);
